module.exports = __webpack_public_path__ + "static/media/logo.9daca651.jpg";